// IntegratedHomeMatrix.jsx — 기능 × 회사 표 (2026-10-01, 시안대로)
//   ✓ = 그 회사가 묶여 있음. 빈 칸 "+"(운영자만) = 그 회사를 미리 켠 편집 창을 연다 — 바로 저장하지 않는다
//   (회사를 더하면 배정된 사람이 그 회사 자료까지 보게 되므로 사람이 경고를 보고 저장해야 한다). 그 외 사람은 "–".
import React from 'react';
import { Check } from 'lucide-react';
import { homeCardCls } from './IntegratedHomeMenuList';
import { useCompanyNames } from '../adminlayout/useCompanyNames';

// isOperator = 고칠 수 있는 사람(운영자 또는 '통합 메뉴 관리' 열쇠, 2026-10-15). 머리글은 작업 대상과 같은 회사 이름.
export default function IntegratedHomeMatrix({ matrix, isOperator, onAddCompany }) {
  const cols = { gridTemplateColumns: `minmax(0, 1.6fr) repeat(${matrix.cols.length}, minmax(0, 1fr))` };
  const nameOf = useCompanyNames();
  return (
    <section className={homeCardCls}>
      <div className="flex flex-col gap-0.5 border-b border-[var(--border)] px-[18px] py-3.5">
        <h2 className="m-0 text-[15px] font-black text-[var(--text)]">기능 × 회사</h2>
        <span className="text-[12px] text-[var(--text-muted)]">어느 기능을 어느 회사끼리 묶었는지 한눈에</span>
      </div>
      <div className="grid px-[18px] pb-1 pt-2.5 text-[11px] font-black text-[var(--text-muted)]" style={cols}>
        <span>기능</span>
        {matrix.cols.map((c) => <span key={c} className="truncate text-center" title={nameOf(c)}>{nameOf(c)}</span>)}
      </div>
      {matrix.rows.map((r) => (
        <div key={r.menu.id} className="grid items-center border-t border-[var(--border)] px-[18px] py-[9px] text-[13px]" style={cols}>
          <span className="truncate font-bold text-[var(--text)]">{r.label}</span>
          {r.cells.map((cell) => (
            <span key={cell.code} className="flex justify-center">
              {cell.on && (
                <span
                  aria-label={`${nameOf(cell.code)} 포함`}
                  className="flex h-6 w-6 items-center justify-center rounded-[7px] bg-accent-50 text-accent-600 dark:bg-accent-500/10 dark:text-accent-300"
                >
                  <Check size={14} strokeWidth={3} />
                </span>
              )}
              {!cell.on && isOperator && (
                <button
                  type="button"
                  aria-label={`${r.label}에 ${nameOf(cell.code)} 더하기`}
                  onClick={() => onAddCompany(r.menu, cell.code)}
                  className="h-6 w-6 cursor-pointer rounded-[7px] border border-dashed border-[var(--border)] bg-[var(--bg-card)] text-[14px] leading-none text-[var(--text-muted)] hover:text-[var(--text)]"
                >
                  +
                </button>
              )}
              {!cell.on && !isOperator && <span className="text-[var(--text-muted)]">–</span>}
            </span>
          ))}
        </div>
      ))}
    </section>
  );
}
